import http from "../../utils/http";

// 급여 항목 목록
export const getSalariesItemsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/salaries/items/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 항목 등록
export const createSalariesItems = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/salaries/items", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 항목 상세
export const getSalariesItems = (itemIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/salaries/items/${itemIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 항목 수정
export const modifySalariesItems = (itemIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/salaries/items/${itemIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 항목 삭제
export const deleteSalariesItems = (itemIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/salaries/items/${itemIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
